import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useRef, useState } from "react";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import SettingsAIcon from "assets/icons/settings_active.svg?react";
import { IFilter } from "dto/IFilter";
import { useAuth } from "react-oidc-context";
import { CreateFilterIncomingModal } from "components/CreateFilterIncomingModal";
import PiImage from "assets/icons/filters/pi.svg?react";
import EmailImage from "assets/icons/filters/email.svg?react";
import PaperImage from "assets/icons/filters/paper.svg?react";
import CryptedImage from "assets/icons/filters/crypted.svg?react";
import AdeImage from "assets/icons/ade.svg?react";
import ArrowRight from "assets/icons/arrow_right.svg?react";
import { useNavigate } from "react-router";
import WorkspaceContext from "contexts/CurrentWorkspace";
import SidebarNotExpandedFilters from "components/SidebarNotExpandedFilters";
import { SidebarDossierFilterModal } from "components/SidebarDossierFilterModal";
import { IDossierFilter } from "dto/Dossier/IDossierFilter";
import { ListType } from "dto/ListType";
import { Tooltip } from "@mui/material";
import Popper from "components/Popper";
import { useMediaQuery } from "usehooks-ts";
import ModalsManagerContext from "contexts/ModalsManager";
import { useTranslation } from "react-i18next";
import { getCompanyId } from "utils/getCompanyId";
import { isRepertoryView } from "utils/repertoryView";

const SidebarFilter: FC<Props> = ({
  id,
  staticId,
  isExpanded,
  getFilters,
  Icon,
  title,
  isDesk,
  isAdmin,
  fullId,
  name,
  isLetter: isLet,
  filters,
  handleChangeFilterState,
  canAddNewFilter,
  hideExpander,
  counters,
  counterId,
  isBeta,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const navigate = useNavigate();
  const [showEditDesk, setShowEditDesk] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [createFilter, setCreateFilter] = useState(false);
  const [edit, setEdit] = useState<IFilter | IDossierFilter | null>(null);
  const [editStaticId, setEditStaticId] = useState<string | null>(null);
  const url = window.location.href;
  const params = url.split("/");
  const refWrapper = useRef(null);
  const ref = useRef(null);
  const [popperElement, setPopperElement] = useState<HTMLElement>(null);
  const auth = useAuth();
  const [showFilters, setShowFilters] = useState(false);
  const isGuest = auth?.user?.profile?.role === "guest";
  const isTemplates = params.includes("templates");
  const isLetter = params.includes("pisma");

  const isCase =
    params.includes("cases") &&
    !params.includes("registry") &&
    !params.includes("courtPortal");
  const isAction = params.includes("actions");
  const isCaseWithAction = isCase && isAction && name === "actions";
  const isDeskEdit = params.includes("desk");
  const isAdminActive = params.includes("admin");
  const isHelpdeskActive = params.includes("helpdesk");
  const isChatActive = params.includes("chat");
  const isCourtPortalSettins =
    params.includes("courtPortal") && params.includes("settings");
  const { modals, setModals } = useContext(ModalsManagerContext);
  const isRepProfile = isRepertoryView();

  const showActive =
    params.includes(fullId ?? name) &&
    !params.includes("registry") &&
    !params.includes("courtPortal") &&
    !isLet &&
    !isLetter &&
    !isCaseWithAction;
  const showActive2 =
    (isLet && isLetter) ||
    (isAdmin && isAdminActive) ||
    (id === "efadc816-ea34-4ba2-bd65-115ffef4ddf1" && isHelpdeskActive) ||
    (id === "3f5962b5-f97a-498c-93a6-c32a814d3283" && isChatActive) ||
    (id === "a8e223ab-de08-4526-8ce3-26a29d1f2356" && isCourtPortalSettins);

  const isHomePage = location.pathname === "/" || isDeskEdit;

  const { filterId, setFilterId } = useContext(WorkspaceContext);


  const hideMenuOnMobile = () => {
    if (isMobile && modals.menu) {
      setModals({ ...modals, menu: false });
    }
  };

  const handleNavigate = (
    fId: string | null | undefined,
    isIncoming: boolean = false,
    force: boolean = false,
  ) => {
    console.log("Navigate menu", fId);

    hideMenuOnMobile();

    if (fId === "szablony") {
      setFilterId("");
      navigate("/templates");
      return;
    }

    if (id === "templates") {
      setFilterId("");
      navigate("/templates");
      return;
    }

    if (id === "115c2bf1-dd9d-42b4-82a2-e8f7487c14a6") {
      setFilterId("");
      //navigate("/templates");
      setModals({ ...modals, contactFormSettings: true });
      return;
    }

    if (id === "115c2bf1-dd9d-42b4-82a2-e8f7487c14a8") {
      setFilterId("");
      setModals({ ...modals, recoveryCode: true });
      return;
    }

    if (id === "115c2bf1-dd9d-42b4-82a2-e8f7487c14a7") {
      setFilterId("");
      //navigate("/templates");
      setModals({ ...modals, settings: true });
      return;
    }

    if (id === "debug") {
      setFilterId("");
      navigate("/debug");
      return;
    }

    if (id === 3) {
      if (fId || isMobile) {
        setFilterId(fId);
        navigate("/cases");
        return;
      }

      setFilterId("");
      // Klucz per firma — CaseCard/CaseList zapisują pod tym samym Id firmy (getCompanyId).
      const CID = localStorage.getItem(`last_case_${getCompanyId() ?? ""}`);

      if (CID) {
        let link = `/cases/${CID}`;
        link = `${link}/chat`;

        navigate(link);
        return;
      }
      navigate("/cases");
      return;
    }

    if (id === 4) {
      setFilterId("");
      navigate("/actions");
      return;
    }
    if (id === 6) {
      setFilterId("");
      if (fId && fId !== "clients") {
        navigate(`/clients/${fId}`);
        return;
      }
      navigate("/clients/all");
      return;
    }

    if (id === 7) {
      setFilterId("");
      if (fId && fId !== "drive") {
        navigate(`/drive/${fId}`);
        return;
      }
      navigate("/drive");
      return;
    }

    if (id === 8) {
      setFilterId("");
      if (fId && fId !== "drive") {
        navigate(`/shares/${fId}`);
        return;
      }
      navigate("/shares");
      return;
    }

    if (id === "d76ad393-712b-4984-968a-f104579d6fa9") {
      setFilterId("");
      navigate(`/`);
      return;
    }

    // Projekty pism / Wychodzące pisma (listy pism autora z Magistratu).
    if (id === "projekty-pism" || id === "wychodzace-pisma") {
      setFilterId("");
      navigate(`/${id}`);
      return;
    }

    // Akceptacja i Podpis — korzeń i dzieci
    if (fId === "as-received") {
      setFilterId(fId);
      navigate(`/packages/as-received/incoming`);
      return;
    }
    if (fId === "as-cc") {
      setFilterId(fId);
      navigate(`/packages/as-cc/incoming`);
      return;
    }
    if (fId === "as-sent") {
      setFilterId(fId);
      navigate(`/acceptance-sign/sent`);
      return;
    }
    if (id === "acceptance-sign-root") {
      setFilterId("");
      navigate(`/packages/as-received/incoming`);
      return;
    }

    // Dekrety — korzeń i dzieci
    if (fId === "decrees-received" || id === "decrees-root") {
      setFilterId(fId ?? "");
      navigate(`/decrees/received`);
      return;
    }
    if (fId === "decrees-issued") {
      setFilterId(fId);
      navigate(`/decrees/issued`);
      return;
    }

    // admin - lista klientów
    if (
      fId === "8f5c2bf1-dd9d-42b4-82a2-e8f7487c14a6" ||
      fId === "3aa7c01a-69f9-4c42-90b4-ccc771d345ea"
    ) {
      setFilterId(fId);
      navigate(`/admin/users`);
      return;
    }

    if (fId === "782b2add-8e74-4b75-a713-e8e4c0cdaba1") {
      setFilterId(fId);
      navigate(`/admin/userRegistry`);
      return;
    }

    if (fId === "b1e7c0a2-2f4d-4d9a-9c5e-7a1b6f0c3d11") {
      setFilterId(fId);
      navigate(`/admin/addressBookVerifications`);
      return;
    }

    // Biuro podawcze → Wychodzące
    if (fId === "d1a2b3c4-e5f6-4a7b-8c9d-0e1f2a3b4c5f") {
      setFilterId(fId);
      navigate(`/biuro-podawcze/outgoing`);
      return;
    }

    // Biuro podawcze → Przychodzące
    if (
      fId === "d1a2b3c4-e5f6-4a7b-8c9d-0e1f2a3b4c5e" ||
      id === "d1a2b3c4-e5f6-4a7b-8c9d-0e1f2a3b4c5d"
    ) {
      setFilterId(fId ?? "");
      navigate(`/biuro-podawcze/incoming`);
      return;
    }

    // Biuro rady → Archiwum sesji
    if (fId === "c3a1b2d4-5e6f-4a7b-8c9d-0e1f2a3b4c62") {
      setFilterId(fId);
      navigate(`/biuro-rady/archiwum`);
      return;
    }

    // Biuro rady → Prowadzenie obrad
    if (fId === "c3a1b2d4-5e6f-4a7b-8c9d-0e1f2a3b4c63") {
      setFilterId(fId);
      navigate(`/biuro-rady/obrady`);
      return;
    }

    // Biuro rady → Radni
    if (fId === "c3a1b2d4-5e6f-4a7b-8c9d-0e1f2a3b4c64") {
      setFilterId(fId);
      navigate(`/biuro-rady/radni`);
      return;
    }

    // Biuro rady → Portal radnego
    if (fId === "c3a1b2d4-5e6f-4a7b-8c9d-0e1f2a3b4c65") {
      setFilterId(fId);
      navigate(`/biuro-rady/portal`);
      return;
    }

    // Biuro rady → Sesja
    if (
      fId === "c3a1b2d4-5e6f-4a7b-8c9d-0e1f2a3b4c61" ||
      id === "c3a1b2d4-5e6f-4a7b-8c9d-0e1f2a3b4c60"
    ) {
      setFilterId(fId ?? "");
      navigate(`/biuro-rady/sesja`);
      return;
    }

    // Prawo miejscowe → Do akceptacji
    if (fId === "b7d3e1c2-4a5f-4b6c-8d9e-0f1a2b3c4d72") {
      setFilterId(fId);
      navigate(`/prawo-miejscowe/akceptacja`);
      return;
    }

    // Prawo miejscowe → Uchwalone
    if (fId === "b7d3e1c2-4a5f-4b6c-8d9e-0f1a2b3c4d73") {
      setFilterId(fId);
      navigate(`/prawo-miejscowe/uchwalone`);
      return;
    }

    // Prawo miejscowe → Do publikacji
    if (fId === "b7d3e1c2-4a5f-4b6c-8d9e-0f1a2b3c4d74") {
      setFilterId(fId);
      navigate(`/prawo-miejscowe/publikacja`);
      return;
    }

    // Prawo miejscowe → Wnioski o publikację (UPE)
    if (fId === "b7d3e1c2-4a5f-4b6c-8d9e-0f1a2b3c4d77") {
      setFilterId(fId);
      navigate(`/prawo-miejscowe/wnioski`);
      return;
    }

    // Prawo miejscowe → Akty obowiązujące
    if (fId === "b7d3e1c2-4a5f-4b6c-8d9e-0f1a2b3c4d75") {
      setFilterId(fId);
      navigate(`/prawo-miejscowe/obowiazujace`);
      return;
    }

    // Prawo miejscowe → Uprawnienia
    if (fId === "b7d3e1c2-4a5f-4b6c-8d9e-0f1a2b3c4d76") {
      setFilterId(fId);
      navigate(`/prawo-miejscowe/uprawnienia`);
      return;
    }

    // Prawo miejscowe → Projekty (także kliknięcie w sam korzeń modułu)
    if (
      fId === "b7d3e1c2-4a5f-4b6c-8d9e-0f1a2b3c4d71" ||
      id === "b7d3e1c2-4a5f-4b6c-8d9e-0f1a2b3c4d70"
    ) {
      setFilterId(fId ?? "");
      navigate(`/prawo-miejscowe/projekty`);
      return;
    }

    // rejestry

    if (fId === "fe598688-7d7b-43a7-b215-4b26f6ab21f4") {
      setFilterId(fId);
      navigate(`/registry/edelivery`);
      return;
    }

    if (fId === "9aa56977-61fc-4ed4-8699-7cd751e5f567") {
      setFilterId(fId);
      navigate(`/registry/courtportal`);
      return;
    }

    if (fId === "b8f3c1a6-5d2e-4f7a-9c3b-1e2d3f4a5b6c") {
      setFilterId(fId);
      navigate(`/registry/pi`);
      return;
    }

    if (fId === "4d41e4ad-0a54-41b9-9631-eb624dd41ad0") {
      setFilterId(fId);
      navigate(`/registry/nota`);
      return;
    }

    if (fId === "37a4fda8-fc8d-4dbf-8d7c-a9509bc495f1") {
      setFilterId(fId);
      navigate(`/registry/cases`);
      return;
    }

    if (fId === "37a4fda8-fc8d-4dbf-8d7c-a9509bc495f2") {
      setFilterId(fId);
      navigate(`/registry/ksef`);
      return;
    }

    if (fId === "a1b2c3d4-e5f6-7890-abcd-ef1234567890") {
      setFilterId(fId);
      navigate(`/registry/contracts`);
      return;
    }

    // Rejestry biura podawczego (Sidebar: registry.mailroom*).
    const mailroomRegisters: Record<string, string> = {
      "6f1c2a3b-4d5e-4f60-8a7b-9c0d1e2f3a41": "mailroom-incoming",
      "6f1c2a3b-4d5e-4f60-8a7b-9c0d1e2f3a42": "mailroom-outgoing",
      "6f1c2a3b-4d5e-4f60-8a7b-9c0d1e2f3a43": "mailroom-internal",
      "6f1c2a3b-4d5e-4f60-8a7b-9c0d1e2f3a44": "mailroom-fees",
      "6f1c2a3b-4d5e-4f60-8a7b-9c0d1e2f3a45": "mailroom-archive",
      "6f1c2a3b-4d5e-4f60-8a7b-9c0d1e2f3a46": "local-law",
      "6f1c2a3b-4d5e-4f60-8a7b-9c0d1e2f3a47": "ebi",
    };
    if (mailroomRegisters[fId]) {
      setFilterId(fId);
      navigate(`/registry/${mailroomRegisters[fId]}`);
      return;
    }

    // Raporty pracy urzędu (Sidebar: reports.*).
    const reports: Record<string, string> = {
      "7a2b3c4d-5e6f-4a70-8b91-c2d3e4f5a611": "incoming",
      "7a2b3c4d-5e6f-4a70-8b91-c2d3e4f5a612": "outgoing",
      "7a2b3c4d-5e6f-4a70-8b91-c2d3e4f5a613": "cases",
      "7a2b3c4d-5e6f-4a70-8b91-c2d3e4f5a614": "overdue",
      "7a2b3c4d-5e6f-4a70-8b91-c2d3e4f5a615": "activity",
    };
    if (reports[fId]) {
      setFilterId(fId);
      navigate(`/reports/${reports[fId]}`);
      return;
    }

    // RADIX (Sidebar: radix.*).
    const radix: Record<string, string> = {
      "8b3c4d5e-6f70-4a81-9b2c-d3e4f5a6b711": "decisions",
      "8b3c4d5e-6f70-4a81-9b2c-d3e4f5a6b712": "reminders",
      "8b3c4d5e-6f70-4a81-9b2c-d3e4f5a6b713": "notifications",
      "8b3c4d5e-6f70-4a81-9b2c-d3e4f5a6b714": "to-send",
      "8b3c4d5e-6f70-4a81-9b2c-d3e4f5a6b715": "sent",
    };
    if (radix[fId]) {
      setFilterId(fId);
      navigate(`/radix/${radix[fId]}`);
      return;
    }

    if (fId === "f1e2d3c4-b5a6-4978-8c0d-1a2b3c4d5e6f") {
      setFilterId(fId);
      navigate(`/registry/zois`);
      return;
    }

    if (fId === "d4e5f6a7-b8c9-4d0e-8f1a-2b3c4d5e6f70") {
      setFilterId(fId);
      navigate(`/registry/rozrachunki`);
      return;
    }

    if (fId === "a9c1f3e2-7b4d-4c8a-9e2f-1d3b5a7c9e10") {
      setFilterId(fId);
      navigate(`/registry/operacje-finansowe`);
      return;
    }

    if (fId === "e7f8a9b0-c1d2-4e3f-9a8b-7c6d5e4f3a2b") {
      setFilterId(fId);
      navigate(`/registry/dziennik`);
      return;
    }

    if (fId === "d8e9f0a1-b2c3-4d5e-8f9a-0b1c2d3e4f5a") {
      setFilterId(fId);
      navigate(`/registry/rejestr-vat`);
      return;
    }

    if (fId === "a1f2e3d4-c5b6-4a7b-9c8d-0e1f2a3b4c5d") {
      setFilterId(fId);
      navigate(`/registry/jpk`);
      return;
    }

    if (fId === "b3c4d5e6-f7a8-4b9c-8d0e-1f2a3b4c5d6e") {
      setFilterId(fId);
      navigate(`/registry/bilanse`);
      return;
    }

    if (fId === "b2c3d4e5-f6a7-8901-bcde-f12345678901") {
      setFilterId(fId);
      navigate(`/registry/kontrahenci`);
      return;
    }

    if (fId === "c3d4e5f6-a7b8-9012-cdef-234567890abc") {
      setFilterId(fId);
      navigate(`/registry/kartoteka-kontrahentow`);
      return;
    }

    // Podatki i opłaty — węzeł „Mapa" otwiera mapę EGiB
    if (
      fId === "a3d8f1c0-2b4e-4f6a-8c1d-3e5f7a9b0c12" ||
      id === "a3d8f1c0-2b4e-4f6a-8c1d-3e5f7a9b0c11"
    ) {
      setFilterId(fId ?? "");
      navigate(`/egib`);
      return;
    }

    // Gospodarka odpadami — węzeł „Mapa" otwiera mapę z wyszukiwaniem gminy
    if (
      fId === "b4e9f2d1-3c5f-4a7b-9d2e-4f6a8b0c1d23" ||
      id === "b4e9f2d1-3c5f-4a7b-9d2e-4f6a8b0c1d22"
    ) {
      setFilterId(fId ?? "");
      navigate(`/gospodarka-odpadami`);
      return;
    }

    // Zamówienia publiczne — węzeł „Otwieranie zamówień" otwiera widok ogłoszeń BZP
    if (
      fId === "c5f0a3e2-4d6a-4b8c-ae3f-5a7b9c0d1e34" ||
      id === "c5f0a3e2-4d6a-4b8c-ae3f-5a7b9c0d1e33"
    ) {
      setFilterId(fId ?? "");
      navigate(`/zamowienia-publiczne`);
      return;
    }

    if (fId === "b1d4e7a2-1c2d-4e5f-8a9b-0a1b2c3d4e5f") {
      setFilterId(fId);
      navigate(`/budget`);
      return;
    }

    if (fId === "c2e5f8b3-2d3e-4f6a-9b0c-1b2c3d4e5f60") {
      setFilterId(fId);
      navigate(`/budget/engagements`);
      return;
    }

    if (fId === "d3f6a9c4-3e4f-5a7b-ac1d-2c3d4e5f6a71") {
      setFilterId(fId);
      navigate(`/budget/report`);
      return;
    }

    if (id === "1b00b326-a7dc-43cb-822a-c725674fc424") {
      return;
    }

    // budżet
    if (id === "e4a7b0d5-4f5a-6b8c-bd2e-3d4e5f6a7b82") {
      setFilterId("");
      navigate(`/budget`);
      return;
    }

    if (fId === "7c145665-8c12-461a-a14f-c2d1c8887d38") {
      setFilterId(fId);
      navigate(`/registry/clients`);
      return;
    }

    // helpdesk
    if (id === "efadc816-ea34-4ba2-bd65-115ffef4ddf1") {
      setFilterId(fId);
      navigate(`/helpdesk/issues`);
      return;
    }

    // chat
    if (id === "3f5962b5-f97a-498c-93a6-c32a814d3283") {
      setFilterId("");
      navigate(`/chat`);
      return;
    }

    // portal sądowy

    if (fId === "058f927c-aeb4-4a30-b8ba-8e6313031567") {
      setFilterId(fId);
      navigate(`/courtPortal/deliverance`);
      return;
    }

    if (fId === "058f927c-aeb4-4a30-b8ba-8e6313031568") {
      setFilterId(fId);
      navigate(`/packages/4E8EC592-3467-4978-A31C-94F1715A11FA/incoming`);
      return;
    }

    if (fId === "90a820b2-8106-4632-8de0-264aba2e606c") {
      setFilterId(fId);
      navigate(`/courtPortal/cases`);
      return;
    }

    if (fId === "cde5e2df-fd50-46d7-851a-dcce39ae71fb") {
      setFilterId(fId);
      navigate(`/courtPortal/calendar`);
      return;
    }

    if (id === "a8e223ab-de08-4526-8ce3-26a29d1f2356") {
      setFilterId("");
      navigate(`/courtPortal/settings`);
      return;
    }

    setFilterId("");
    let url = `/packages/${fId}`;

    if (title !== "Pisma") {
      if (id === 1) {
        url += "/incoming";
      } else {
        url += "/outcoming";
      }
    } else {
      url += "/pisma";
    }

    navigate(url);
  };

  const handleClick = (e: any) => {
    const el = e.target;

    console.log(el?.className?.search?.("expanderWrapper"));
    if (
      el?.className?.search?.("expanderWrapper") !== -1 &&
      el?.className?.search?.("expanderWrapper") !== undefined
    ) {
      return;
    }

    handleNavigate(fullId, id === 1 ? true : false);
  };

  const subList = filters.find(
    (filter) => filter.Id === params[4] || filter.Id === params?.[5],
  );
  const mainListActive = !isExpanded && subList?.List === id;

  const globalCounter = counters.find(
    (counter) =>
      (counter.filterId == staticId && staticId) || counter.type === counterId,
  );

  return (
    <>
      <div
        className={`${styles.filtersWrapper} ${!isExpanded && styles.small}`}
      >
        <div
          onMouseEnter={() => {
            if (isDesk) {
              setShowEditDesk(true);
            }
          }}
          onMouseLeave={() => {
            setShowEditDesk(false);
          }}
          onClick={handleClick}
          ref={refWrapper}
          className={`${styles.title} ${!isExpanded && styles.isNotExpanded} ${
            showActive && styles.active
          } ${showActive2 && styles.active} ${
            !isExpanded && showActive && styles.notExpandedActive
          } ${isDesk && isHomePage && styles.active} ${
            mainListActive && styles.active
          } ${mainListActive && styles.notExpandedActive}`}
        >
          <div className={`${styles.name} ${!isExpanded && styles.removeGap}`}>
            <Icon onClick={handleClick} className={styles.headerIcon} />
            {!isExpanded && (showActive || mainListActive) && (
              <ArrowRight
                onClick={() => {
                  handleChangeFilterState(title);
                  setShowFilters(true);
                }}
                className={styles.arrowR}
              />
            )}
            {isExpanded && (
              <>
                <span className={styles.textName}>{title}</span>
                {isBeta && <span className={styles.beta}>BETA</span>}
              </>
            )}

            {!isExpanded && isBeta && <span className={styles.beta2}>β</span>}
            {/* wyłączona edycja na poziomie statycznego 'Przychodzące' */}
            {/* {staticId === EMenuFilters.UnhandledIncomignId && (
              <SettingsAIcon
                onClick={(e) => {
                  setEditStaticId(EMenuFilters.UnhandledIncomignId);
                  setEdit(null);
                  setCreateFilter(true);
                  e.stopPropagation();
                }}
                className={styles.icon}
              />
            )} */}
          </div>
          <div className={styles.iconsWrapper}>
            {globalCounter?.count > 0 && (
              <div
                className={`${styles.counter} ${
                  !isExpanded && styles.levitate
                }`}
              >
                {globalCounter?.count ?? 0}
              </div>
            )}
            {isExpanded && (
              <div
                onClick={(e) => {
                  if (!hideExpander && !isDesk) {
                    setIsOpen(!isOpen);
                    handleChangeFilterState(title);
                  }
                  e.stopPropagation();
                }}
                className={styles.expanderWrapper}
              >
                {!hideExpander && isExpanded && !isDesk && (
                  <FontAwesomeIcon
                    className={classNames(
                      styles.expander,
                      isOpen && styles.expanderActive,
                    )}
                    icon={faChevronDown}
                  />
                )}
                {isDesk && showEditDesk && !isGuest && (
                  <SettingsAIcon
                    className={styles.icone}
                    onClick={() => {
                      if (isDesk) {
                        const isEdit =
                          window.location.href.search("edit") !== -1;

                        if (isEdit) {
                          navigate("/");
                          return;
                        }
                        navigate("/desk/edit");
                        return;
                      }
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            maxHeight:
              isOpen && isExpanded
                ? `${36 * (filters.length + 1) + 20}px`
                : "0px",
          }}
          ref={ref}
          className={`${styles.list}`}
        >
          {filters
            .filter(
              (filter) =>
                !!filter.Name.length && (!filter.hidden || !filter.hidden()),
            )
            .map((filter: IFilter) => (
              <div
                key={`filter_${filter.Id}`}
                onClick={() => {
                  handleNavigate(filter.Id, filter?.isIncoming ?? true);
                }}
                className={`${styles.box}
              ${params.includes(filter.Id) && styles.active} ${
                  fullId === "A666CC3E-A2AF-49AA-AB95-54DA6CB4CC99:1" &&
                  isTemplates &&
                  styles.active
                } ${edit === filter && styles.active} ${
                  filterId === filter.Id && styles.active
                }
              `}
              >
                <div className={styles.boxWrapper}>
                  <span className={styles.boxText}>{filter.Name}</span>
                  {!filter.Static && (
                    <div
                      onClick={(e) => {
                        setPopperElement(e.target as HTMLElement);
                        setEditStaticId(null);
                        setEdit(filter);
                        setCreateFilter(true);
                        e.stopPropagation();
                      }}
                    >
                      <SettingsAIcon className={styles.icon} />
                    </div>
                  )}
                </div>

                <div className={styles.counterWrapper}>
                  {counters.find(
                    (c) =>
                      c.filterId === filter.Id || c.type === filter.counterId,
                  )?.count > 0 && (
                    <Tooltip title={t("sidebar.unreadPackages")}>
                      <div className={styles.counter}>
                        {counters.find(
                          (c) =>
                            c.filterId === filter.Id ||
                            c.type === filter.counterId,
                        )?.count ?? 0}
                      </div>
                    </Tooltip>
                  )}
                </div>
              </div>
            ))}
          {canAddNewFilter && !isGuest && (
            <div
              onClick={(e) => {
                setPopperElement(e.currentTarget as HTMLElement);
                setCreateFilter(true);
                setEdit(null);
              }}
              className={styles.addWrapper}
            >
              <div className={styles.addButton}>+</div>
              <div className={styles.addText}>{t("sidebar.newList")}</div>
            </div>
          )}
        </div>

        {createFilter && (
          <>
            {id === ListType.Incoming && (
              <Popper
                anchorEl={popperElement ?? refWrapper?.current}
                setOpen={setCreateFilter}
                open={createFilter}
                placement="bottom-start"
              >
                <CreateFilterIncomingModal
                  getFilters={getFilters}
                  toggle={setCreateFilter}
                  typed={[
                    {
                      id: "EDeliveryMessage",
                      name: t("packages.eDelivery"),
                      active: false,
                      image: AdeImage,
                    },
                    {
                      id: "CourtPortalDeliverance",
                      name: t("packages.courtDelivery"),
                      active: false,
                      image: PiImage,
                    },
                    {
                      id: "CourtPortalDocument",
                      name: t("packages.otherCourtDocs"),
                      active: false,
                      image: PiImage,
                    },
                    {
                      id: "Parcel",
                      name: t("packages.paper"),
                      active: false,
                      image: PaperImage,
                    },
                    {
                      id: "ContactMessage",
                      name: t("packages.confidential"),
                      active: false,
                      image: CryptedImage,
                    },
                    {
                      id: "NotaMessage",
                      name: t("packages.notaPackages"),
                      active: false,
                      image: CryptedImage,
                    },
                    {
                      id: "Email",
                      name: "E-mail",
                      active: false,
                      image: EmailImage,
                    },
                  ]}
                  listType={ListType.Incoming}
                  listRef={ref}
                  initialValues={edit as IFilter}
                  staticId={editStaticId}
                />
              </Popper>
            )}
            {id === ListType.Outgoing && (
              <Popper
                anchorEl={popperElement ?? refWrapper?.current}
                setOpen={setCreateFilter}
                open={createFilter}
                placement="bottom-start"
              >
                <CreateFilterIncomingModal
                  getFilters={getFilters}
                  toggle={setCreateFilter}
                  typed={[
                    {
                      id: "EDeliveryMessage",
                      name: t("packages.eDelivery"),
                      active: false,
                      image: AdeImage,
                    },
                    {
                      id: "CourtPortalApplication",
                      name: t("packages.courtApplications"),
                      active: false,
                      image: PiImage,
                    },
                    {
                      id: "NotaMessage",
                      name: t("packages.notaPackages"),
                      active: false,
                      image: CryptedImage,
                    },
                    {
                      id: "Email",
                      name: "E-mail",
                      active: false,
                      image: EmailImage,
                    },
                  ]}
                  listType={ListType.Outgoing}
                  listRef={ref}
                  initialValues={edit as IFilter}
                />
              </Popper>
            )}
            {id === ListType.Cases && (
              <Popper
                anchorEl={popperElement ?? refWrapper?.current}
                setOpen={setCreateFilter}
                open={createFilter}
                placement="bottom-start"
              >
                <CreateFilterIncomingModal
                  showStatus={true}
                  getFilters={getFilters}
                  toggle={setCreateFilter}
                  typed={[]}
                  listType={ListType.Cases}
                  listRef={ref}
                  initialValues={edit as IFilter}
                />
              </Popper>
            )}
            {id === ListType.Tasks && (
              <Popper
                anchorEl={popperElement ?? refWrapper?.current}
                setOpen={setCreateFilter}
                open={createFilter}
                placement="bottom-start"
              >
                <CreateFilterIncomingModal
                  showStatus={true}
                  getFilters={getFilters}
                  toggle={setCreateFilter}
                  typed={[]}
                  listType={ListType.Tasks}
                  listRef={ref}
                  initialValues={edit as IFilter}
                />
              </Popper>
            )}
            {id === ListType.Participants && (
              <Popper
                anchorEl={popperElement ?? refWrapper?.current}
                setOpen={setCreateFilter}
                open={createFilter}
                placement="bottom-start"
              >
                <CreateFilterIncomingModal
                  showStatus={false}
                  getFilters={getFilters}
                  toggle={setCreateFilter}
                  typed={[]}
                  listType={ListType.Participants}
                  listRef={ref}
                  initialValues={edit as IFilter}
                />
              </Popper>
            )}
            {id === ListType.Drive && (
              <Popper
                anchorEl={popperElement ?? refWrapper?.current}
                setOpen={setCreateFilter}
                open={createFilter}
                placement="bottom-start"
              >
                <SidebarDossierFilterModal
                  getFilters={getFilters}
                  toggle={setCreateFilter}
                  listType={ListType.Drive}
                  listRef={ref}
                  initialValues={edit as IDossierFilter}
                />
              </Popper>
            )}
            {id === 8 && (
              <Popper
                anchorEl={popperElement ?? refWrapper?.current}
                setOpen={setCreateFilter}
                open={createFilter}
                placement="bottom-start"
              >
                <SidebarDossierFilterModal
                  getFilters={getFilters}
                  toggle={setCreateFilter}
                  listType={ListType.Shares}
                  listRef={ref}
                  initialValues={edit as IDossierFilter}
                />
              </Popper>
            )}
          </>
        )}
      </div>
      {showFilters && (
        <SidebarNotExpandedFilters
          filterName={title}
          handleNavigate={handleNavigate}
          setShowFilters={setShowFilters}
          filters={filters}
          Icon={Icon}
        />
      )}
    </>
  );
};

export default SidebarFilter;
